import { personInfoFrag } from '../../../../../../utils/type/person.common-type';

export const debtorsFrag = `
    id
    folderId
    serviceId
    personId
    person {
        ${personInfoFrag}
    }
    debt
    documents {
        id
        issueDate
        debt
    }
`;
